import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { UserState } from './user.state';
import { ProfilePicture } from '../../models/user/profile-picture.model';
import { Observable } from 'rxjs';
import { LoadProfilePicture } from './user.actions';

@Injectable({
  providedIn: 'root'
})
export class UserFacade {
  private readonly store = inject(Store);

  @Select(UserState.profilePicture) profilePicture$: Observable<ProfilePicture | undefined>;

  loadProfilePicture(userId: string) {
    this.store.dispatch(new LoadProfilePicture(userId));
  }
}
